<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">BATTLE <span class="half1">OF</span> <span class="titled">BRITAIN</span> <span class="titledd">1940</span></h1>
<p class="sub-title"><span class="bold">THE FINEST HOUR’S HUMAN COST</span></p>
<p class="author">Dilip Sarkar MBE FRHistS</p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?1b242f62